export default __webpack_public_path__ + "static/media/appstore_badge.f34e9a28.svg";